export default "__VITE_ASSET__DtFJ7iXG__"